import { gql } from "graphql-request";

const SERVER_DELETE_DOCUMENT_TEMPLATE = gql`
  mutation SERVER_DeleteDocumentTemplate($id: ID!) {
    deleteDocumentTemplate(id: $id)
  }
`;
export default SERVER_DELETE_DOCUMENT_TEMPLATE;